import { ContactType } from '@features/contacts/types/contactType'
import { InvoiceFormReceiver } from '@features/invoices/types/invoiceForm/invoiceFormReceiver'

export const getReceiverIcon = (receiver?: InvoiceFormReceiver | null) => {
  if (!receiver) {
    return 'contactRound'
  }

  return receiver.type === ContactType.Company ? 'store' : 'userRound'
}
